import React, { useState } from 'react';
import { Button, Card, Icon } from 'semantic-ui-react';
import TokensTable from '../../components/TokensTable';
import { useTranslation } from 'react-i18next';
import { isRoot } from '../../helpers';
import BatchAddTokenModelsModal from './BatchAddTokenModelsModal';

const Token = () => {
  const { t } = useTranslation();
  const [batchModalOpen, setBatchModalOpen] = useState(false);

  return (
    <div className='dashboard-container'>
      <Card fluid className='chart-card'>
        <Card.Content>
          <Card.Header
            className='header'
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <span>{t('token.title')}</span>
            {isRoot() && (
              <Button
                primary
                size='small'
                onClick={() => setBatchModalOpen(true)}
              >
                <Icon name='plus' />
                {t('token.batch_add.button')}
              </Button>
            )}
          </Card.Header>
          <TokensTable />
        </Card.Content>
      </Card>
      <BatchAddTokenModelsModal
        open={batchModalOpen}
        onClose={() => setBatchModalOpen(false)}
      />
    </div>
  );
};

export default Token;
